export default {
      id: "project2-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/icons.31feac93.svg#project2",
      toString: function () {
        return this.url;
      }
    }